import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import PrivateRoute from './components/PrivateRoute';
import Landing from './components/Landing';
import Loading from './components/Loading';
import './App.css';

function App() {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <Loading message="Initializing..." />;
  }

  return (
    <div className="App">
      <PrivateRoute>
        <Landing />
      </PrivateRoute>
    </div>
  );
}

export default App;